/**
 * Created by nguyenlet on 08/11/2016.
 */
import {Injectable} from '@angular/core';

function _window():any {
  // return the native window obj
  return window;
}

function _document():any {
  // return the native document obj
  return document;
}

@Injectable()
export class WindowRef {

  get nativeWindow():any {
    return _window();
  }
}

@Injectable()
export class DocumentRef {

  get nativeDocument():any {
    return _document();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/common/refs.ts